import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {
    $allowedActionsForInvoice,
    $doesInvoiceExist,
    setShowDeleteInvoiceModal,
} from 'models/documents/invoices/common';

import {
    $invoiceCreationPage,
    arrStores,
    invoiceCreationPage,
} from 'models/documents/invoices/create';

import {$invoiceCreatingPending} from 'models/documents/invoices/details';

import {setXmlFile} from '../helpers/buildXml';

import {Button, ButtonsContainer, FlexContainer} from './styled';

export const STEPS_LENGTH = 4;

export const ControlSection = ({
    onSubmit,
    nextIndex,
    nextIsDisabled = false,
}: {
    onSubmit: any;
    nextIndex?: number;
    nextIsDisabled?: boolean;
}) => {
    const {t} = useTranslation();
    // const invoiceIsRemoved = useStore($invoiceIsRemoved);
    // const newInvoiceIsDone = useStore($newInvoiceIsDone);
    // const history = useHistory();
    const doesInvoiceExist = useStore($doesInvoiceExist);
    const invoiceCreatingPending = useStore($invoiceCreatingPending);
    const currentPageIndex = useStore($invoiceCreationPage);
    const allowedActionsForInvoice = useStore($allowedActionsForInvoice);
    const GEN_INFO = 'pages.documents.invoices.create';

    const generalDataFromStore = useStore(arrStores);

    // useEffect(() => {
    //     console.log(newInvoiceIsDone);
    //     if (newInvoiceIsDone || invoiceIsRemoved) {
    //         history.goBack();
    //     }
    // }, [newInvoiceIsDone, invoiceIsRemoved]);

    function turnPageNext() {
        if (nextIndex) {
            onSubmit(nextIndex);
        } else {
            onSubmit();
        }
    }
    function turnPagePrev() {
        invoiceCreationPage(currentPageIndex - 1);
    }

    function showXml() {
        setXmlFile(generalDataFromStore);
    }

    function sendForCreatingInvoice() {
        onSubmit();
    }

    return (
        <ButtonsContainer>
            {allowedActionsForInvoice.delete && doesInvoiceExist ? (
                <div>
                    <Button
                        typeView="delete"
                        type="button"
                        onClick={() => setShowDeleteInvoiceModal(true)}
                    >
                        {t(`${GEN_INFO}.buttons.delete`)}
                    </Button>
                </div>
            ) : (
                <div />
            )}
            <FlexContainer>
                {currentPageIndex ? (
                    <Button typeView="back" type="button" onClick={turnPagePrev}>
                        {t(`${GEN_INFO}.buttons.back`)}
                    </Button>
                ) : (
                    <></>
                )}
                {currentPageIndex >= STEPS_LENGTH - 1 ? (
                    allowedActionsForInvoice.sendToApproval ? (
                        <Button
                            disabled={invoiceCreatingPending}
                            onClick={sendForCreatingInvoice}
                            typeView="next"
                            type="button"
                        >
                            {t(`${GEN_INFO}.buttons.submit`)}
                        </Button>
                    ) : (
                        <></>
                    )
                ) : (
                    <Button
                        disabled={nextIsDisabled}
                        typeView="next"
                        type="button"
                        onClick={turnPageNext}
                    >
                        {t(`${GEN_INFO}.buttons.next`)}
                    </Button>
                )}
            </FlexContainer>
        </ButtonsContainer>
    );
};
